import { Box, Typography } from "@mui/material";
import React from "react";
import AiIcon from "../assets/icons/AiIcon";

type Props = {
  message?: string;
};

export function DraftingOverlay({ message = "Drafting email…" }: Props) {
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        bgcolor: (theme) => (theme.palette.mode === "dark" ? "rgba(30, 30, 30, 0.85)" : "rgba(255, 255, 255, 0.85)"),
        backdropFilter: "blur(2px)",
        zIndex: 1,
        borderRadius: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 48,
          height: 48,
          borderRadius: "50%",
          background: "linear-gradient(135deg, #005AF8 0%, #9A1BF9 100%)",
          color: "common.white",
          animation: "draftPulse 1.5s ease-in-out infinite",
          "@keyframes draftPulse": {
            "0%, 100%": { opacity: 0.7, transform: "scale(0.95)" },
            "50%": { opacity: 1, transform: "scale(1.05)" },
          },
          "& svg": { width: 28, height: 28 },
        }}
      >
        <AiIcon />
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
        {message}
      </Typography>
    </Box>
  );
}
